import { Injectable } from "@angular/core";
import  * as info_modales from '../data/description-planes.json'
import { InfoModales } from "src/app/home/models/plans.interface";

@Injectable({
    providedIn: 'root',
  })
  export class InfoModalPlanesService {
    infoModales = info_modales;

    async GetInfoModales():Promise<InfoModales[]>{
        return this.infoModales.info_modales
    }
  }